export default "__VITE_ASSET__BsddhjBL__"